import React from 'react';
import {
	Dialog,
	DialogContent,
	makeStyles,
	Grid,
	Box,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { toggleEnquiryModal } from '../../reducers/UiReducer';
import SubscribeForm from '../../form/SubscribeForm';
import EnquiryForm from '../../form/EnquiryForm';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: 'transparent',
		backdropFilter: 'blur(2px)',
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(3),
		[theme.breakpoints.down('xs')]: {
			top: theme.spacing(2.5),
		},
		color: theme.palette.grey[500],
	},
}));

const EnquiryModal = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { enquiryModal } = useSelector((state) => state.ui);
	const handleClose = () => {
		dispatch(toggleEnquiryModal(false));
	};
	return (
		<Dialog
			PaperProps={{
				style: {
					borderRadius: 12,
					maxWidth: 500,
				},
			}}
			TransitionProps={{
				style: { backgroundColor: 'transparent' },
			}}
			onClose={handleClose}
			aria-labelledby='customized-dialog-title'
			className={classes.root}
			open={enquiryModal}
			fullWidth={true}
			maxWidth={'xs'}>
			<DialogContent
				style={{
					// paddingBottom: 20,
					// paddingTop: 50,
					// padding: 0,
					textAlign: 'center',
				}}>
				<Box
					onClick={handleClose}
					style={{ textAlign: 'end', cursor: 'pointer' }}>
					<i class='fa fa-times' aria-hidden='true'></i>
				</Box>
				<span style={{ textAlign: 'center', fontSize: 26 }}>QUICK ENQUIRY</span>
				<EnquiryForm />
			</DialogContent>
		</Dialog>
	);
};

export default EnquiryModal;
